import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FormField({ id, label, value, onChange, type = 'text', placeholder, helpText, required = false, rows }) {
    const handleChange = (e)=>{
        onChange(e.target.value);
    };
    const baseClassName = 'w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500';
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("label", {
                htmlFor: id,
                className: "block text-sm font-medium text-gray-700 mb-1",
                children: [
                    label,
                    " ",
                    required && '*'
                ]
            }),
            rows ? /*#__PURE__*/ _jsx("textarea", {
                id: id,
                value: value,
                onChange: handleChange,
                rows: rows,
                className: `${baseClassName} font-mono text-xs`,
                placeholder: placeholder
            }) : /*#__PURE__*/ _jsx("input", {
                id: id,
                type: type,
                value: value,
                onChange: handleChange,
                className: baseClassName,
                placeholder: placeholder
            }),
            helpText && /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-gray-500 mt-1",
                children: helpText
            })
        ]
    });
}
